<template>
  <AppTabRoute
    :tabs="[
      { name: 'Lançamentos', route: 'cashflow.list' },
      { name: 'Categorias', route: 'cashflow-category.list' },
    ]"
  ></AppTabRoute>
</template>

<script>
export default {
  name: 'CashFlowTabs',
};
</script>

<style>
</style>